



























import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import { EssaySupportText } from '@/store/modules/essay/state';

export default Vue.extend({
  components: {
    VueMarkdown,
  },
  props: {
    supportTexts: {
      type: Array,
      default: () => [''],
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
});
